import { render, staticRenderFns } from "./comNuRc.vue?vue&type=template&id=68df08c6&"
import script from "./comNuRc.vue?vue&type=script&lang=js&"
export * from "./comNuRc.vue?vue&type=script&lang=js&"
import style0 from "./comNuRc.vue?vue&type=style&index=0&id=68df08c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports